import { useTranslation } from 'react-i18next'

import { CellCentered } from './CellCentered'

import type { NotFoundCellProps } from './types'

export const NotFoundCell = ({ columnsCount, message }: NotFoundCellProps): React.JSX.Element => {
  const { t } = useTranslation('common')

  return (
    <CellCentered columnsCount={columnsCount}>{message ?? t('filter.nothingFound')}</CellCentered>
  )
}
